import { type Question, Serializer, type SurveyModel } from "survey-core";

const OPTIONAL_MOBILE_PROPERTY = "optionalMobile";

export const optionalMobileProperties = () => {
  Serializer.addProperty("question", {
    name: OPTIONAL_MOBILE_PROPERTY,
    displayName: "Optional on mobile devices",
    type: "boolean",
    category: "general",
    default: false,
  });
};

export const applyOptionalMobileLogic = (model: SurveyModel) => {
  const deviceType = model.getVariable("deviceType");
  const isMobile = deviceType === "android" || deviceType === "ios";

  if (!isMobile) {
    return;
  }

  const setOptionalOnMobile = () => {
    model.getAllQuestions().forEach((question: Question) => {
      if (question.getPropertyValue(OPTIONAL_MOBILE_PROPERTY) === true) {
        question.isRequired = false;
      }
    });
  };

  setOptionalOnMobile();

  if (model.onLoaded) {
    model.onLoaded.add((sender: SurveyModel) => {
      sender.getAllQuestions().forEach((question: Question) => {
        if (question.getPropertyValue(OPTIONAL_MOBILE_PROPERTY) === true) {
          question.isRequired = false;
        }
      });
    });
  }
};
